import { render, staticRenderFns } from "./PostgresMonitoring.vue?vue&type=template&id=5be41ad6&scoped=true"
import script from "./PostgresMonitoring.vue?vue&type=script&lang=js"
export * from "./PostgresMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be41ad6",
  null
  
)

export default component.exports